/* Lon Fame — shared scroll behaviour for lf- sections.
   Safe to include once per section: guarded so it only initializes once
   even if the same <script src> tag appears in multiple sections. */
(function () {
  if (window.__lfScrollInit) return;
  window.__lfScrollInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var groups = document.querySelectorAll('[data-lf-reveal-group]');
    if (!groups.length) return;

    groups.forEach(function (group) {
      group.classList.add('lf-reveal-ready');
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-lf-reveal]').forEach(function (el) {
        el.classList.add('lf-in');
      });
      return;
    }

    var items = document.querySelectorAll('[data-lf-reveal]');
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('lf-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );

    items.forEach(function (el, index) {
      el.style.transitionDelay = Math.min(index % 4, 3) * 90 + 'ms';
      io.observe(el);
    });
  }

  function initParallax() {
    if (reduceMotion) return;
    var layers = document.querySelectorAll('[data-lf-parallax]');
    if (!layers.length) return;

    var ticking = false;

    function update() {
      ticking = false;
      layers.forEach(function (layer) {
        var rect = layer.parentElement.getBoundingClientRect();
        var progress = 1 - (rect.top + rect.height / 2) / (window.innerHeight + rect.height);
        var shift = (progress - 0.5) * 60;
        layer.style.transform = 'translateY(' + shift.toFixed(1) + 'px) scale(1.08)';
      });
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function initEarlyAccessForm() {
    var forms = document.querySelectorAll('[data-lf-early-access-form]');
    forms.forEach(function (form) {
      form.addEventListener('submit', function () {
        var button = form.querySelector('.lf-early-access__submit');
        var label = button && button.querySelector('.lf-early-access__submit-label');
        if (!button) return;
        button.setAttribute('data-lf-loading', '');
        button.disabled = true;
        if (label) label.textContent = 'Enviando…';
        // No preventDefault: the native Shopify customer form still submits
        // and redirects back with the real server-confirmed result.
      });
    });

    var success = document.querySelector('[data-lf-server-success]');
    if (success) {
      success.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    }
  }

  function initVideoMotion() {
    var videos = document.querySelectorAll('video[autoplay]');
    if (!videos.length) return;
    if (reduceMotion) {
      videos.forEach(function (v) {
        v.removeAttribute('autoplay');
        v.pause();
        v.currentTime = 0;
      });
      return;
    }
    // Pause any offscreen autoplay video to save battery/CPU; resume when back in view.
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.play().catch(function () {});
          } else {
            entry.target.pause();
          }
        });
      },
      { threshold: 0.1 }
    );
    videos.forEach(function (v) { io.observe(v); });
  }

  function init() {
    initReveal();
    initParallax();
    initEarlyAccessForm();
    initVideoMotion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
